import * as Types from './types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type StreamDetailFragment = { __typename?: 'Stream', id: string, name: string, created: string, updated: string, environmentId: string, isMandatory: boolean, containers: { __typename?: 'StreamContainersConnection', totalCount: number }, triggerEvents: { __typename?: 'TriggerEventsConnection', totalCount: number } };

export type StreamListQueryVariables = Types.Exact<{
  environmentId: Types.Scalars['String']['input'];
  orderBy?: Array<Types.StreamsOrderBy> | Types.StreamsOrderBy;
}>;


export type StreamListQuery = { __typename?: 'Query', streams?: { __typename?: 'StreamsConnection', totalCount: number, nodes: Array<{ __typename?: 'Stream', id: string, name: string, created: string, updated: string, environmentId: string, isMandatory: boolean, containers: { __typename?: 'StreamContainersConnection', totalCount: number }, triggerEvents: { __typename?: 'TriggerEventsConnection', totalCount: number } }> } | null };

export type GetStreamQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  environmentId: Types.Scalars['String']['input'];
}>;


export type GetStreamQuery = { __typename?: 'Query', stream?: { __typename?: 'Stream', id: string, name: string, created: string, updated: string, environmentId: string, isMandatory: boolean, containers: { __typename?: 'StreamContainersConnection', totalCount: number }, triggerEvents: { __typename?: 'TriggerEventsConnection', totalCount: number } } | null };

export type AddStreamMutationVariables = Types.Exact<{
  environmentId: Types.Scalars['String']['input'];
  name: Types.Scalars['String']['input'];
}>;


export type AddStreamMutation = { __typename?: 'Mutation', createStream?: { __typename?: 'CreateStreamPayload', stream?: { __typename?: 'Stream', id: string, name: string, created: string, updated: string, environmentId: string, isMandatory: boolean, containers: { __typename?: 'StreamContainersConnection', totalCount: number }, triggerEvents: { __typename?: 'TriggerEventsConnection', totalCount: number } } | null } | null };

export type EditStreamMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  environmentId: Types.Scalars['String']['input'];
  name: Types.Scalars['String']['input'];
}>;


export type EditStreamMutation = { __typename?: 'Mutation', updateStream?: { __typename?: 'UpdateStreamPayload', stream?: { __typename?: 'Stream', id: string, name: string, created: string, updated: string, environmentId: string, isMandatory: boolean, containers: { __typename?: 'StreamContainersConnection', totalCount: number }, triggerEvents: { __typename?: 'TriggerEventsConnection', totalCount: number } } | null } | null };

export type DeleteStreamMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  environmentId: Types.Scalars['String']['input'];
}>;


export type DeleteStreamMutation = { __typename?: 'Mutation', updateStream?: { __typename?: 'UpdateStreamPayload', stream?: { __typename?: 'Stream', id: string, name: string, created: string, updated: string, environmentId: string, isMandatory: boolean, containers: { __typename?: 'StreamContainersConnection', totalCount: number }, triggerEvents: { __typename?: 'TriggerEventsConnection', totalCount: number } } | null } | null };

export const StreamDetailFragmentDoc = gql`
    fragment StreamDetail on Stream {
  id
  name
  created
  updated
  environmentId
  isMandatory
  containers: streamContainersByEnvironmentIdAndStreamId(
    filter: {enabled: {equalTo: true}}
  ) {
    totalCount
  }
  triggerEvents: activeTriggers {
    totalCount
  }
}
    `;
export const StreamListDocument = gql`
    query StreamList($environmentId: String!, $orderBy: [StreamsOrderBy!]! = [UPDATED_DESC]) {
  streams(
    orderBy: $orderBy
    condition: {environmentId: $environmentId, deleted: false}
  ) {
    nodes {
      ...StreamDetail
    }
    totalCount
  }
}
    ${StreamDetailFragmentDoc}`;

/**
 * __useStreamListQuery__
 *
 * To run a query within a React component, call `useStreamListQuery` and pass it any options that fit your needs.
 * When your component renders, `useStreamListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStreamListQuery({
 *   variables: {
 *      environmentId: // value for 'environmentId'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useStreamListQuery(baseOptions: Apollo.QueryHookOptions<StreamListQuery, StreamListQueryVariables> & ({ variables: StreamListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StreamListQuery, StreamListQueryVariables>(StreamListDocument, options);
      }
export function useStreamListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StreamListQuery, StreamListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StreamListQuery, StreamListQueryVariables>(StreamListDocument, options);
        }
export function useStreamListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StreamListQuery, StreamListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StreamListQuery, StreamListQueryVariables>(StreamListDocument, options);
        }
export type StreamListQueryHookResult = ReturnType<typeof useStreamListQuery>;
export type StreamListLazyQueryHookResult = ReturnType<typeof useStreamListLazyQuery>;
export type StreamListSuspenseQueryHookResult = ReturnType<typeof useStreamListSuspenseQuery>;
export type StreamListQueryResult = Apollo.QueryResult<StreamListQuery, StreamListQueryVariables>;
export const GetStreamDocument = gql`
    query GetStream($id: String!, $environmentId: String!) {
  stream(id: $id, environmentId: $environmentId) {
    ...StreamDetail
  }
}
    ${StreamDetailFragmentDoc}`;

/**
 * __useGetStreamQuery__
 *
 * To run a query within a React component, call `useGetStreamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStreamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStreamQuery({
 *   variables: {
 *      id: // value for 'id'
 *      environmentId: // value for 'environmentId'
 *   },
 * });
 */
export function useGetStreamQuery(baseOptions: Apollo.QueryHookOptions<GetStreamQuery, GetStreamQueryVariables> & ({ variables: GetStreamQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStreamQuery, GetStreamQueryVariables>(GetStreamDocument, options);
      }
export function useGetStreamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStreamQuery, GetStreamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStreamQuery, GetStreamQueryVariables>(GetStreamDocument, options);
        }
export function useGetStreamSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStreamQuery, GetStreamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStreamQuery, GetStreamQueryVariables>(GetStreamDocument, options);
        }
export type GetStreamQueryHookResult = ReturnType<typeof useGetStreamQuery>;
export type GetStreamLazyQueryHookResult = ReturnType<typeof useGetStreamLazyQuery>;
export type GetStreamSuspenseQueryHookResult = ReturnType<typeof useGetStreamSuspenseQuery>;
export type GetStreamQueryResult = Apollo.QueryResult<GetStreamQuery, GetStreamQueryVariables>;
export const AddStreamDocument = gql`
    mutation AddStream($environmentId: String!, $name: String!) {
  createStream(input: {stream: {name: $name, environmentId: $environmentId}}) {
    stream {
      ...StreamDetail
    }
  }
}
    ${StreamDetailFragmentDoc}`;

/**
 * __useAddStreamMutation__
 *
 * To run a mutation, you first call `useAddStreamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddStreamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addStreamMutation, { data, loading, error }] = useAddStreamMutation({
 *   variables: {
 *      environmentId: // value for 'environmentId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useAddStreamMutation(baseOptions?: Apollo.MutationHookOptions<AddStreamMutation, AddStreamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddStreamMutation, AddStreamMutationVariables>(AddStreamDocument, options);
      }
export type AddStreamMutationHookResult = ReturnType<typeof useAddStreamMutation>;
export type AddStreamMutationResult = Apollo.MutationResult<AddStreamMutation>;
export type AddStreamMutationOptions = Apollo.BaseMutationOptions<AddStreamMutation, AddStreamMutationVariables>;
export const EditStreamDocument = gql`
    mutation EditStream($id: String!, $environmentId: String!, $name: String!) {
  updateStream(
    input: {id: $id, environmentId: $environmentId, patch: {name: $name}}
  ) {
    stream {
      ...StreamDetail
    }
  }
}
    ${StreamDetailFragmentDoc}`;

/**
 * __useEditStreamMutation__
 *
 * To run a mutation, you first call `useEditStreamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditStreamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editStreamMutation, { data, loading, error }] = useEditStreamMutation({
 *   variables: {
 *      id: // value for 'id'
 *      environmentId: // value for 'environmentId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useEditStreamMutation(baseOptions?: Apollo.MutationHookOptions<EditStreamMutation, EditStreamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditStreamMutation, EditStreamMutationVariables>(EditStreamDocument, options);
      }
export type EditStreamMutationHookResult = ReturnType<typeof useEditStreamMutation>;
export type EditStreamMutationResult = Apollo.MutationResult<EditStreamMutation>;
export type EditStreamMutationOptions = Apollo.BaseMutationOptions<EditStreamMutation, EditStreamMutationVariables>;
export const DeleteStreamDocument = gql`
    mutation DeleteStream($id: String!, $environmentId: String!) {
  updateStream(
    input: {id: $id, environmentId: $environmentId, patch: {deleted: true}}
  ) {
    stream {
      ...StreamDetail
    }
  }
}
    ${StreamDetailFragmentDoc}`;

/**
 * __useDeleteStreamMutation__
 *
 * To run a mutation, you first call `useDeleteStreamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStreamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStreamMutation, { data, loading, error }] = useDeleteStreamMutation({
 *   variables: {
 *      id: // value for 'id'
 *      environmentId: // value for 'environmentId'
 *   },
 * });
 */
export function useDeleteStreamMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStreamMutation, DeleteStreamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStreamMutation, DeleteStreamMutationVariables>(DeleteStreamDocument, options);
      }
export type DeleteStreamMutationHookResult = ReturnType<typeof useDeleteStreamMutation>;
export type DeleteStreamMutationResult = Apollo.MutationResult<DeleteStreamMutation>;
export type DeleteStreamMutationOptions = Apollo.BaseMutationOptions<DeleteStreamMutation, DeleteStreamMutationVariables>;